

export default pair => {

}